import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const ReviewsSlider = () => {
  // Sample review data
  const reviews = [
    {
      id: 1,
      name: "Michael Thompson",
      location: "Wheat Farmer, Kansas",
      rating: 5,
      content: "This platform has completely transformed how I sell my harvest. I've connected with buyers I never would have found otherwise and increased my profits by 30% this season!",
    },
    {
      id: 2,
      name: "Sarah Johnson",
      location: "Organic Vegetable Grower, California", 
      rating: 5,
      content: "The farm progress tracking feature has been invaluable. I can now monitor all aspects of my farm's performance and make data-driven decisions. My crop yield is up by 25% since I started using this app.",
    },
    {
      id: 3,
      name: "David Martinez",
      location: "Berry Farm, Oregon",
      rating: 4,
      content: "Being able to connect directly with other farmers in my area has been incredible. We've shared equipment, knowledge, and even collaborated on larger orders.",
    },
    {
      id: 4,
      name: "Priya Patel",
      location: "Family Farm, Georgia",
      rating: 5,
      content: "The inventory management system is so intuitive! I'm saving hours each week on administrative work and can focus more on actual farming.",
    },
    {
      id: 5,
      name: "Robert Wilson",
      location: "Cattle & Crop Farmer, Texas",
      rating: 5,
      content: "I was skeptical at first, but this platform has opened up new markets for my produce. The direct-to-consumer option has allowed me to set better prices and build customer loyalty.",
    },
    {
      id: 6,
      name: "Emily Chen",
      location: "Urban Farm, New York",
      rating: 4,
      content: "As a small urban farmer, I didn't think I needed technology like this - I was wrong! The community advice alone has been worth it, not to mention the increased sales.",
    }
  ];

  // Render star rating
  const renderStars = (rating) => {
    return (
      <div className="rating">
        {[...Array(5)].map((_, i) => (
          <span key={i} className={i < rating ? "star filled" : "star"}>
            ★
          </span>
        ))}
      </div>
    );
  };

  // Slider settings
  const settings = {
    dots: false,
    infinite: true,
    arrows: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
    ]
  };

  return (
    <section className="reviews-section">
      <div className="reviews-header">
        <h2>What Farmers Are Saying</h2>
        <p>Join thousands of farmers already growing their business with us</p>
      </div>
      
      <div className="reviews-container">
        <Slider {...settings}>
          {reviews.map((review) => (
            <div key={review.id} className="review-card">
              {renderStars(review.rating)}
              <p className="review-content">{review.content}</p>
              <div className="reviewer-info">
                <h4>{review.name}</h4>
                <p>{review.location}</p>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
};

export default ReviewsSlider;